// extracted by mini-css-extract-plugin
export var productCard = "product-card-module--product-card--eZ5af";
export var productCard__kicker = "product-card-module--product-card__kicker--wVuWe";
export var productCard__title = "product-card-module--product-card__title--tgvOm";
export var productCard__link = "product-card-module--product-card__link--MMvQd";
export var productCard__description = "product-card-module--product-card__description--9HisV";
export var productCard__desc = "product-card-module--product-card__desc--08kWk";